import { useMemo } from 'react';

import useUsersData from '../api/queries/useUsersData.js';
import type { OptionItem } from '../types/shared.js';

const useUserList = () => {
  const { data } = useUsersData();

  return useMemo(() => {
    if (!data) {
      return [];
    }

    return data.reduce<OptionItem[]>((acc, user) => {
      if (!user.isActive) {
        return acc;
      }

      acc.push({
        value: String(user.id),
        label: `${user.firstName} ${user.lastName}`,
      });

      return acc;
    }, []);
  }, [data]);
};

export default useUserList;
